<div class="p-grid">
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Allow orders outside of FocusOnline Active Time</div>
		<div class="mb-3">
			<p-inputSwitch
				[(ngModel)]="orderType.ignoreOOEnabledTime"
				[disabled]="!orderType.atTable"
				(onChange)="changesToSaveChange.emit(true)"
				pTooltip="@table will be enabled outside of the times setup in Focus for your FocusOnline active times."
			>
			</p-inputSwitch>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Auto Close Check (minutes)</div>
		<div class="mb-3">
			<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.autoCloseCheck" [disabled]="!orderType.atTable"> </p-inputSwitch>
		</div>
		<div>Leave Check Open (minutes)</div>
		<div class="mb-3">
			<p-inputNumber
				(onInput)="changesToSaveChange.emit(true)"
				styleClass="w-100"
				[(ngModel)]="orderType.checkLeaveOpenMinutes"
				[disabled]="!orderType.atTable && !orderType.autoCloseCheck"
			>
			</p-inputNumber>
		</div>
		<div>SMS Before Check Close (minutes)</div>
		<div class="mb-3">
			<p-inputNumber
				(onInput)="changesToSaveChange.emit(true)"
				styleClass="w-100"
				[(ngModel)]="orderType.smsBeforeCloseMinutes"
				[disabled]="!orderType.atTable && !orderType.autoCloseCheck"
			>
			</p-inputNumber>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column"></div>
</div>
